import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Space } from 'antd';
import { Radio, Select } from 'ui/styled';
import FilterDropdown from 'components/FilterDropdown';
import { verifiedValues } from 'components/VerifiedDropdown/helpers';
import WithinRow from './styled';
export var DEFAULT_TITLE = 'Verified';
var ALL = 'all';
var VERIFIED = 'verified';
var UNVERIFIED = 'unverified';
var VerifiedDropdown = function (_a) {
    var defaultValue = _a.defaultValue, filtersUpdateSeveral = _a.filtersUpdateSeveral, _b = _a.dataTest, dataTest = _b === void 0 ? 'VerifiedDropdown' : _b;
    var getDefaultValue = function () {
        if ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.is_verified) === true)
            return VERIFIED;
        if ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.is_verified) === false)
            return UNVERIFIED;
        return ALL;
    };
    var _c = useState(getDefaultValue()), value = _c[0], setValue = _c[1];
    var _d = useState((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.verified_after) || null), verifiedWithinValue = _d[0], setVerifiedWithinValue = _d[1];
    var verifiedText = "Only ".concat(VERIFIED, " ").concat(verifiedWithinValue ? "within ".concat(verifiedWithinValue) : '');
    var unverifiedText = "Only ".concat(UNVERIFIED);
    var getDefaultTitle = function () {
        if ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.is_verified) === false)
            return "".concat(DEFAULT_TITLE, ": ").concat(unverifiedText);
        if ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.is_verified) === true)
            return "".concat(DEFAULT_TITLE, ": ").concat(verifiedText);
        return DEFAULT_TITLE;
    };
    var _e = useState(getDefaultTitle()), title = _e[0], setTitle = _e[1];
    var onResetVerified = function () {
        setTitle(DEFAULT_TITLE);
        setValue(ALL);
        setVerifiedWithinValue(undefined);
        filtersUpdateSeveral([
            { is_verified: undefined },
            { verified_after: undefined }
        ]);
    };
    var onSaveVerified = function () {
        switch (value) {
            case ALL:
                onResetVerified();
                setTitle("Verified: ".concat(ALL));
                break;
            case UNVERIFIED:
                setTitle("".concat(DEFAULT_TITLE, ": ").concat(unverifiedText));
                filtersUpdateSeveral([
                    { is_verified: false },
                    { verified_after: undefined }
                ]);
                break;
            case VERIFIED:
                setTitle("".concat(DEFAULT_TITLE, ": ").concat(verifiedText));
                filtersUpdateSeveral([
                    { is_verified: true },
                    { verified_after: verifiedWithinValue }
                ]);
                break;
            default:
                break;
        }
    };
    var onChange = function (e) {
        setValue(e.target.value);
    };
    var options = verifiedValues.map(function (item) { return ({
        label: item.name,
        value: item.value
    }); });
    var content = (_jsxs(_Fragment, { children: [_jsx(Radio.Group, { onChange: onChange, value: value, style: { width: '100%' }, children: _jsxs(Space, { orientation: "vertical", style: { width: '100%' }, children: [_jsx(Radio, { value: ALL, children: "All" }), _jsx(Radio, { value: UNVERIFIED, children: "Only Not Verified" }), _jsx(Radio, { value: VERIFIED, children: "Only Verified" })] }) }), value === VERIFIED && (_jsxs(WithinRow, { children: ["Within", _jsx(Select, { onChange: function (v) { return setVerifiedWithinValue(v); }, defaultValue: verifiedWithinValue, options: options, style: { width: 100, marginLeft: 10 } })] }))] }));
    return (_jsx(FilterDropdown, { title: title, content: content, hasDefaultValue: !!(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.verified_after) || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.is_verified) === true, onSave: onSaveVerified, onReset: onResetVerified, dataTest: dataTest }));
};
export default VerifiedDropdown;
